import { Button } from "@/_component/Common";
import { NO_IMAGE } from "@/_constant";
import { useLanguageContext } from "@/hooks";
import { renderHeading, renderPrice, renderSubtitle, renderTitle } from "@/utility";
import AddonPlanDropdown from "../common/plans/AddonPlanDropdown";

export default function ListingCard({ item, addonPlans, onPreview, onSubmit, onEdit, onDelete, onChoosePlan, dropdownPlaceholder }) {
    const { language } = useLanguageContext();

    return (

        <div className="card shadow-sm border border-1" style={{ minWidth: "24.5rem", maxWidth: "24.8rem", width: "100%" }}>
            <img className="card-img-top cursor-pointer" style={{ maxHeight: "10rem", margin: "auto", height: "100%", width: "100%", objectFit: "cover" }} src={item?.thumbnailUrl || NO_IMAGE} alt='listing image' onClick={() => onPreview(item)} />
            <div className="card-body px-2">
                <div className="d-flex justify-content-between align-items-center">
                    <h6 className="fw-bold" style={{ textWrap: "nowrap" }}>{renderPrice(item) || renderTitle(item)}</h6>
                    <div>
                        {<AddonPlanDropdown dropdownPlaceholder={dropdownPlaceholder} onChoosePlan={onChoosePlan} addonPlans={addonPlans} item={item} />}
                    </div>
                </div>
                <div className="mt-3">
                    <h6 className="card-title fw-bold " style={{ textWrap: "balance" }}> {renderPrice(item) ? renderTitle(item) : ""} </h6>
                    {/* <h6 className="card-title fw-bold " style={{ textWrap: "balance" }}> {renderPrice(item) ? renderTitle(item) : item.title } </h6> */}
                    <div className="d-flex flex-column gap-1 fs-7 mt-2">
                        <span className="card-subtitle mb-2 text-body-secondary" style={{ whiteSpace: "pre-wrap" }}>{renderHeading(item)}</span>
                        <span className="card-subtitle mb-2 text-body-secondary" style={{ whiteSpace: "pre-wrap" }}>{renderSubtitle(item)}</span>
                    </div>
                </div>
            </div>
            <div className="card-footer py-3">
                <div className="d-flex justify-content-between align-items-center gap-3">
                    <div className="d-inline-flex gap-3">
                        <Button noSpacing primary onClick={() => onEdit(item)}><i className="bi bi-pencil-fill"></i></Button>
                        <Button noSpacing danger onClick={() => onDelete(item)}><i className="bi bi-trash3-fill"></i></Button>
                    </div>
                    <div>
                        <Button primary noSpacing onClick={() => onSubmit(item)}>{language('label.submit')}</Button>
                    </div>
                </div>
            </div>
        </div>
    );
}